export const DS_COMMENT_BUBBLE_CLASSES = {
  Root: "ds-comment-bubble",
  Other: "ds-comment-bubble--other",
  Own: "ds-comment-bubble--own",
  Content: "ds-comment-bubble__content",
} as const;
